import React from 'react'
import { Card, CardContent, Typography, Button, Grid } from "@mui/material";
import { projects } from 'src/projects';


export default function FaqPage() {
  return (
    <Grid container spacing={3} justifyContent="center" style={{ padding: "20px" }}>
      {projects.map((project) => (
        <Grid item xs={12} sm={6} md={4} key={project.name}>
          <Card style={{ textAlign: "center", borderRadius: "10px" }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                {project.name}
              </Typography>
              <Typography variant="body1" color="textSecondary">
                {project.bot}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                href={project.link}
                target="_blank"
                style={{ marginTop: "10px" }}
              >
                Open
              </Button>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}
